// extracted by mini-css-extract-plugin
export const root = "SupplyBlock-module--root--bzV3p";
export const title = "SupplyBlock-module--title--3NMCB";
export const subtitle = "SupplyBlock-module--subtitle--TgVyt";
export const content = "SupplyBlock-module--content--3Hoxu";
export const hasButtonBelow = "SupplyBlock-module--has-button-below--jPVy5";
export const disclaimer = "SupplyBlock-module--disclaimer--wY29P";
export const items = "SupplyBlock-module--items--16Cfh";
export const ctaButton = "SupplyBlock-module--ctaButton--StI5Z";